import React from 'react';
import {Component} from 'react';
import EntityIcon from '../../components/Common/EntityIcon/EntityIcon';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import Scrollbars from 'react-custom-scrollbars';
import {getLocalizedText, texts} from '../../constants/TextConst';
import {togglePinActiveScreens} from '../../_shared/GWTBridge/invoke/footerPanel';
import {tabs} from '../FormFooter/consts';
import {EntityType} from '../../constants/EntityTypes';
import {sendMonitor} from '../../utils/monitoring';

interface TabItem {
    title: string;
    type?: EntityType;
    isCurrent?: boolean;
    menuButton?: any;
    action: (event, menuButton, screenId?) => void;
    pageItem?: any;
    screenId?: string;
    closeAction?: (item) => void;
}

interface ScrollState {
    scrolledToEnd: boolean;
    selectedIndex: number;
}

class ActiveScreens extends Component<any, ScrollState> {
    scrollbar;
    wrapperRef;
    constructor(props) {
        super(props);

        this.state = {
            scrolledToEnd: false,
            selectedIndex: -1
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        nextProps.activeScreens.forEach((item, index) => {
            if (item.isCurrent && item.isCurrent(item.menuButton)) {
                if (this.state.selectedIndex !== index) {
                    this.setState({selectedIndex: index});
                }
                return;
            }
        });
    }

    closeActiveScreens() {
        const {funcs} = this.props;
        if (funcs) {
            funcs.closeOpnedScreens();
        }
    }

    renderItems(dataItems: Array<TabItem>) {
        return dataItems.map((item, index) => {
            return (
                <div
                    key={index}
                    title={item.title}
                    tabIndex={index}
                    ref={item => {
                        this['item_' + index] = item;
                    }}
                    className={`content ${index === this.state.selectedIndex ? 'selected' : ''}`}
                    onClick={e => {
                        sendMonitor('Form_ActiveScreens_Click');
                        item.action(e, item.menuButton, item.screenId);
                    }}
                >
                    <EntityIcon type={item.type} />
                    <div className="title">{item.title}</div>
                    <Icon
                        icon={PriorityIcon.x}
                        iconColor="white"
                        componentClasses="close-screen"
                        onClick={e => {
                            e.stopPropagation();
                            item.closeAction(item.menuButton);
                        }}
                    />
                </div>
            );
        });
    }

    render() {
        const isPinned = localStorage.getItem('isActiveScreensPinned');
        return (
            <React.Fragment>
                <header className="side-active-screens-header">
                    <div className="header-title">
                        <div>
                            <span>{this.props.tabs[tabs.ACTIVE_SCREENS].title}</span>
                            <span
                                className="close-all"
                                onClick={() => {
                                    this.closeActiveScreens();
                                }}
                            >
                                {getLocalizedText(texts.closeAll)}
                            </span>
                        </div>
                        <div className="title-buttons">
                            <div className="active-screens-header-pin">
                                <Icon
                                    icon={isPinned ? PriorityIcon.pinPinned : PriorityIcon.pin}
                                    skin="standart"
                                    iconColor="primary-0"
                                    onClick={() => {
                                        sendMonitor('Form_ActiveScreens_Pinned');
                                        togglePinActiveScreens(true);
                                    }}
                                />
                            </div>
                            <Icon
                                icon={PriorityIcon.x}
                                skin="standart"
                                onClick={() => togglePinActiveScreens(false)}
                            />
                        </div>
                    </div>
                </header>
                <section className="side-active-screens">
                    <Scrollbars
                        ref={s => (this.scrollbar = s)}
                        className={`scroll-area`}
                        renderThumbVertical={props => (
                            <div {...props} className="footer-items-scroller" />
                        )}
                        autoHeight
                        autoHeightMin={window.innerHeight - 160}
                        autoHeightMax={window.innerHeight - 160}
                    >
                        {this.renderItems(this.props.activeScreens)}
                    </Scrollbars>
                </section>
            </React.Fragment>
        );
    }
}

export default ActiveScreens;
